import { gatewayClient } from './api-grpc';
import authStore from '../stores/auth.store';
import useAuthStore from '../stores/auth.store';
import {
  CheckTokenResponse,
  CheckTokenResponseSchema,
  LoginResponse,
  RefreshTokenRequestSchema,
  RegisterResponse,
} from '../gen/proto/api/gateway/v1/gateway_pb';
import { create } from '@bufbuild/protobuf';

export const authApi = {
  login: async function (username: string, password: string): Promise<LoginResponse> {
    try {
      return await gatewayClient.login({
        username: username,
        password: password,
      });
    } catch (error) {
      throw error;
    }
  },

  logout: async function (refreshToken: string): Promise<boolean> {
    try {
      const response = await gatewayClient.logout({
        refreshToken: refreshToken,
      });

      return response.success;
    } catch (error) {
      throw error;
    }
  },

  register: async function (params: { username: string; password: string; email: string }): Promise<RegisterResponse> {
    try {
      return await gatewayClient.register({
        username: params.username,
        password: params.password,
        email: params.email,
      });
    } catch (error) {
      throw error;
    }
  },

  checkToken: async function (token: string): Promise<CheckTokenResponse> {
    try {
      return await gatewayClient.checkToken({
        token: token,
      });
    } catch (error) {
      return create(CheckTokenResponseSchema, {
        tokenValid: false,
        email: '',
        username: '',
      });
    }
  },

  refreshToken: async function (): Promise<string | undefined> {
    try {
      const { refreshToken } = authStore.getState();
      if (!refreshToken) return undefined;

      const request = create(RefreshTokenRequestSchema, {
        refreshToken: refreshToken,
      });
      const response = await gatewayClient.refreshToken(request);

      if (response.refreshToken) {
        useAuthStore.getState().setToken(response.accessToken, response.refreshToken);
        return refreshToken;
      }

      return undefined;
    } catch (error) {
      return undefined;
    }
  },
};
